// Sombras suaves con tinte de color, estilo Minimal dashboard

const GREY_500 = '145, 158, 171';

function createShadow(px) {
  return `0 ${px}px ${px * 2}px 0 rgba(${GREY_500}, 0.16)`;
}

const shadows = [
  'none',
  createShadow(1),
  createShadow(2),
  createShadow(3),
  createShadow(4),
  createShadow(5),
  createShadow(6),
  createShadow(7),
  createShadow(8),
  createShadow(9),
  createShadow(10),
  createShadow(11),
  createShadow(12),
  createShadow(13),
  createShadow(14),
  createShadow(15),
  createShadow(16),
  createShadow(17),
  createShadow(18),
  createShadow(19),
  createShadow(20),
  createShadow(21),
  createShadow(22),
  createShadow(23),
  createShadow(24),
];

export const customShadows = {
  z1: createShadow(1),
  z8: createShadow(8),
  z12: createShadow(12),
  z16: createShadow(16),
  z20: createShadow(20),
  z24: createShadow(24),
  card: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
  dropdown: '0 0 2px 0 rgba(145, 158, 171, 0.24), -20px 20px 40px -4px rgba(145, 158, 171, 0.24)',
  primary: '0 8px 16px 0 rgba(32, 101, 209, 0.24)',
};

export default shadows;
